<template>
  <!-- PRESS-MODAL -->
  <div v-if="pressmodal" class="presse">
    <div class="presse__wrapper" :class="$mq">
      <div class="presse__right">
        <img src="@/assets/images/modals/presse.jpg" alt />
      </div>
      <div class="presse__left">
        <h1>Betreuende Presseagentur:</h1>
        <address>
          <div class="presse__name">
            {{ $config.press.agencies[$config.press.agency].name }}
          </div>
          <div class="presse__person">
            {{ $config.press.agencies[$config.press.agency].person }}
          </div>
          <div class="presse__adresse">
            {{ $config.press.agencies[$config.press.agency].street }}
            <br />
            {{ $config.press.agencies[$config.press.agency].city }}
            <br />
            {{ $config.press.agencies[$config.press.agency].phone }}
            <br />
            <a
              :href="
                'mailto:' + $config.press.agencies[$config.press.agency].email
              "
              >{{ $config.press.agencies[$config.press.agency].email }}</a
            >
          </div>
        </address>
        <p class="presse__server">
          <a href="//www.filmpresskit.de/" target="_blank"
            >Zum Presseserver >></a
          >
        </p>
        <div class="presse__close" @click="close">&times;</div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'
export default {
  data() {
    return {
      pressmodal: false,
    }
  },
  created() {
    /* eslint-disable-next-line no-undef */
    EventBus.$on(
      'pressmodal',
      function () {
        this.pressmodal = true
      }.bind(this)
    )
  },
  methods: {
    close() {
      this.pressmodal = false
    },
  },
}
</script>

<style lang="scss">
/** @format */

.presse {
  $self: &;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 222;
  &__wrapper {
    display: flex;
    flex-direction: row;
    position: relative;
    border: 2px solid black;
    width: 33%;
    &.sm {
      flex-direction: column;
      #{$self}__right {
        display: none;
      }
    }
    &.sm,
    &.md {
      width: 100%;
      #{$self}__right {
        min-width: auto;
        background-color: BLACK;
      }
      #{$self}__left {
        padding: 2rem 0 2rem 2rem;
      }
    }
    &.lg {
      width: 50%;
    }
    #{$self}__right {
      min-width: 283px;
    }
    #{$self}__left {
      position: relative;
      background-color: white;
      color: black;
      padding: 2rem;
      flex: 1;
      text-align: left;
      h1 {
        font-weight: 700;
        margin-bottom: 2rem;
        font-size: 24px;
        // font-bold mb-4 text-2xl lg:text-3xl leading-none
      }
      address {
        font-style: normal;
        #{$self}__name {
          font-weight: 700;
          font-size: 20px;
        }
      }
      a {
        color: black;
        &:hover {
          color: var(--clr-red);
        }
      }
      #{$self}__close {
        position: absolute;
        top: 0;
        right: 0;
        color: black;
        margin-right: 10px;
        margin-top: 16px;
        cursor: pointer;
        font-size: 48px;
        line-height: 0;
        font-weight: 700;
        &:hover {
          color: red;
        }
      }
    }
  }
}
</style>
